exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".billing-status-bar[data-v-012134c6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #666;\n}[dir] .billing-status-bar[data-v-012134c6] {\n  padding: 10px 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #f0f0f0;\n}\n.billing-by[data-v-012134c6] {\n  color: #999;\n  font-size: 12px;\n}\n[data-v-012134c6] .vs-popup--close {\n  display: none !important;\n}\n", ""]);

// exports
